module.exports = __webpack_public_path__ + "img/77432.8d5f3a0b.svg";